import React, { useState, useEffect } from 'react'
import CustomTable from '../organisms/CustomTable'
import ViewBid from '../molecules/ViewBid'
import { useDispatch, useSelector } from 'react-redux'
import ReCounterDialog from '../organisms/RecounterDialogBox'
import EditDialog from '../organisms/EditBidDialog'
import BidCancelBox from '../molecules/CancelBox'
import ReBidSuccessBox from '../molecules/ReBidSucces'
import ReBidCancelBox from '../molecules/ReBidCancel'
import AcceptPopUp from '../molecules/AcceptPopUp'
import Button from '../atoms/Button'
import Cancelbid from '../molecules/CancelBid'
import CancelListPopup from '../molecules/CancelListPopup'
import useScrollToTop from '../../hooks/useScrollToTop'
import { ReactComponent as Filter } from '../svgs/filter.svg'
import SearchBar from '../atoms/SearchButton'
import FilterBox from '../molecules/FilterBoxPage'
import ModifyBid from '../organisms/ModifyBid'
import { myBids } from '../../utils/API/myBids'
import { Skeleton } from 'antd'
import { getHeaderData } from '../../utils/helper/mybids-page'
import { cancelBids } from '../../utils/API/cancelbid'
import { useNavigate } from 'react-router-dom'
import CounterOfferDialog from '../organisms/CounterOfferDialog'
import action from '../svgs/action.svg'
import Pagination from '../atoms/Pagination'
import toast from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { completeBids } from '../../utils/API/completeBids'
import Badge from '../atoms/Badge/index.jsx'
import ViewPopUp from '../organisms/ViewPopUp/index.jsx'
import ActionRequired from '../organisms/ActionRequiredPopUp/index.jsx'
import ViewDocumentPopUp from '../organisms/ViewDocumentPopUp/index.jsx'
import UploadCompleteBidsDocuments from '../molecules/UploadCompleteBidsDocuments/index.jsx'
import RetirementPopup from '../molecules/RetireDailogBox/RetirementPopup.jsx'

const getLabel = {
  'Bid Accepted': 'Bid Accepted',
  'Payment Completed': 'Payment Completed',
  'Document Uploaded': 'Document Uploaded',
  'Action Required': 'Action Required',
  'Transaction Completed': 'Transaction Completed',
  'Payment Link Expired': 'Payment Link Expired',
  'Document Upload Link Expires': 'Document Upload Link Expires',
  'Response Received': 'Response Received',
  'Response Recieved': 'Response Recieved',
  'Transaction Canceled': 'Transaction Canceled',
  'Documents Upload Link Expires': 'Documents Upload Link Expires'
}

const ActionButtons = ({
  onModifyClick,
  onEditClick,
  onUnbidClick,
  onViewBidClick,
  onViewClick,
  onCancelListClick,
  onRequiredClick,
  onUploadClick,
  onPaymentClick,
  onActionClick,
  onViewDocumentsClick,
  userType,
  selectedButton,
  status,
  rowData,
  isCountered,
  bidType
}) => {
  return (
    <div className='flex items-center justify-center gap-x-3 relative '>
      {userType === 'seller' && (
        <>
          {selectedButton === 'BidReceived' && (
            <Button
              color={'blue'}
              varient={'primary'}
              onClick={() => onModifyClick(rowData)}
              className={
                'text-white w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium'
              }
            >
              Modify
            </Button>
          )}
          {selectedButton === 'BidReceived' && (
            <Button
              varient={'primary'}
              onClick={() => onViewBidClick(rowData.bid_Id)}
              className={
                'w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
              }
            >
              View Bids
            </Button>
          )}
          {selectedButton === 'BidReceived' && (
            <Button
              varient={'secondary'}
              onClick={() => onCancelListClick(rowData)}
              className={
                'w-[4.3rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
              }
            >
              Unlist
            </Button>
          )}
          {selectedButton === 'CancelledBid' && (
            <Button
              varient={'primary'}
              onClick={() => onViewClick(rowData)}
              className={
                'w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
              }
            >
              View
            </Button>
          )}

          {selectedButton === 'CompletedBid' &&
            (status === 'Action Required' ||
              status === 'Response Received') && (
              <Button
                varient={'secondary'}
                onClick={() => onActionClick(rowData)}
                className={
                  'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium   rounded text-white  bg-red-600 '
                }
              >
                Action Required
              </Button>
            )}
          {selectedButton === 'CompletedBid' && status === 'Payment Completed' && (
            <Button
              varient={'primary'}
              onClick={() => onUploadClick()}
              className={
                'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
              }
            >
              Upload Document
            </Button>
          )}
        </>
      )}

      {userType === 'buyer' && isCountered && (
        <>
          {selectedButton === 'BidPlaced' && (
            <Button
              color={'blue_300'}
              varient={'secondary'}
              onClick={() => onRequiredClick(rowData.bid_Id)}
              className={
                'w-[4.7rem] text-white bg-red-300 pl-1 text-left text-[0.5625rem]  text-[#C90202] h-[1.875rem] font-medium'
              }
            >
              Action required
            </Button>
          )}
          {selectedButton === 'BidPlaced' && (
            <Button
              varient={'secondary'}
              onClick={() => onUnbidClick(rowData.bid_Id)}
              className={
                'w-[4.7rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
              }
            >
              Unbid
            </Button>
          )}
          {selectedButton === 'BidPlaced' && (
            <Button
              varient={'secondary'}
              onClick={() => onRequiredClick()}
              className={
                ' w-[9px] h-[9px] bg-red-800 cursor-pointer absolute  right-[-20px] '
              }
            >
              <img src={action} alt='Action Icon' />
            </Button>
          )}
        </>
      )}

      {userType === 'buyer' && !isCountered && (
        <>
          {selectedButton === 'BidPlaced' && (
            <Button
              color={'blue_300'}
              varient={'secondary'}
              onClick={() => onEditClick(rowData.bid_Id)}
              className={
                'w-[4.7rem] text-[0.5625rem] h-[1.875rem] text-blue-800'
              }
            >
              Edit
            </Button>
          )}
          {selectedButton === 'BidPlaced' && (
            <Button
              varient={'secondary'}
              onClick={() => onUnbidClick(rowData.bid_Id)}
              className={
                'w-[4.7rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
              }
            >
              Unbid
            </Button>
          )}

          {selectedButton === 'CancelledBid' && (
            <Button
              varient={'primary'}
              onClick={() => onViewClick(rowData)}
              className={
                'w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
              }
            >
              View
            </Button>
          )}

          {selectedButton === 'CompletedBid' && status === 'Bid Accepted' && (
            <Button
              varient={'primary'}
              onClick={() => onPaymentClick()}
              className={
                'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
              }
            >
              Make Payment
            </Button>
          )}
          {selectedButton === 'CompletedBid' &&
            (status === 'Action Required' ||
              status === 'Response Received') && (
              <Button
                varient={'secondary'}
                onClick={() => onActionClick(rowData)}
                className={
                  'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium   rounded text-white  bg-red-600 '
                }
              >
                Action Required
              </Button>
            )}

          {selectedButton === 'CompletedBid' &&
            status === 'Transaction Completed' && (
              <Button
                varient={'primary'}
                onClick={() => onViewDocumentsClick()}
                className={
                  'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-white bg-blue-800'
                }
              >
                View Documents
              </Button>
            )}
        </>
      )}
      {userType === 'trader' && selectedButton === 'BidReceived' && (
        <>
          <Button
            color={'blue'}
            varient={'primary'}
            onClick={() => onModifyClick(rowData)}
            className={
              'text-white w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium'
            }
          >
            Modify
          </Button>

          <Button
            varient={'primary'}
            onClick={() => onViewBidClick(rowData.bid_Id)}
            className={
              'w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
            }
          >
            View Bids
          </Button>

          <Button
            varient={'secondary'}
            onClick={() => onCancelListClick(rowData)}
            className={
              'w-[4.3rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
            }
          >
            Unlist
          </Button>
        </>
      )}
      {userType === 'trader' && isCountered && selectedButton === 'BidPlaced' && (
        <>
          <Button
            color={'blue_300'}
            varient={'secondary'}
            onClick={() => onRequiredClick(rowData.bid_Id)}
            className={
              'w-[4.3rem] text-white bg-red-300 p-0 text-left text-[0.5625rem]  text-[#C90202] h-[1.875rem] font-medium'
            }
          >
            Action required
          </Button>
          <Button
            varient={'secondary'}
            onClick={() => onUnbidClick(rowData.bid_Id)}
            className={
              'w-[4.3rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
            }
          >
            Unbid
          </Button>
          <Button
            varient={'secondary'}
            onClick={() => onRequiredClick()}
            className={
              ' w-[9px] h-[9px] bg-red-800 cursor-pointer absolute  right-[-20px] '
            }
          >
            <img src={action} alt='Action Icon' />
          </Button>
        </>
      )}
      {userType === 'trader' && !isCountered && selectedButton === 'BidPlaced' && (
        <>
          <Button
            color={'blue_300'}
            varient={'secondary'}
            onClick={() => onEditClick(rowData.bid_Id)}
            className={'w-[4.3rem] text-[0.5625rem] h-[1.875rem] text-blue-800'}
          >
            Edit
          </Button>
          <Button
            varient={'secondary'}
            onClick={() => onUnbidClick(rowData.bid_Id)}
            className={
              'w-[4.3rem] text-[0.5625rem] h-[1.875rem] text-[#C90202] bg-[#C9020240]'
            }
          >
            Unbid
          </Button>
        </>
      )}
      {userType === 'trader' && selectedButton === 'CancelledBid' && (
        <>
          <Button
            varient={'primary'}
            onClick={() => onViewClick(rowData)}
            className={
              'w-[3.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
            }
          >
            View
          </Button>
        </>
      )}
      {userType === 'trader' &&
        selectedButton === 'CompletedBid' &&
        status === 'Bid Accepted' &&
        bidType === 'Buy' && (
          <Button
            varient={'primary'}
            onClick={() => onPaymentClick()}
            className={
              'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-blue-800  bg-blue-500 bg-opacity-25'
            }
          >
            Make Payment
          </Button>
        )}
      {userType === 'trader' &&
        selectedButton === 'CompletedBid' &&
        (status === 'Action Required' || status === 'Response Received') && (
          <Button
            varient={'secondary'}
            onClick={() => onActionClick(rowData)}
            className={
              'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium   rounded text-white  bg-red-600 '
            }
          >
            Action Required
          </Button>
        )}

      {userType === 'trader' &&
        selectedButton === 'CompletedBid' &&
        status === 'Transaction Completed' && (
          <Button
            varient={'primary'}
            onClick={() => onViewDocumentsClick()}
            className={
              'w-[5.75rem] text-[0.5625rem] h-[1.875rem] font-medium  flex-shrink-0 rounded text-white bg-blue-800'
            }
          >
            View Documents
          </Button>
        )}
    </div>
  )
}

const ListingsPage = () => {
  const dispatch = useDispatch()
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false)
  const [isViewBidOpen, setViewBidOpen] = useState(false)
  const [isViewAcceptOpen, setViewAcceptOpen] = useState(false)
  const [isModifyPriceOpen, setModifyPriceOpen] = useState(false)
  const [isCancelBidOpen, setCancelBidOpen] = useState(false)
  const [isCancelBidSuccess, setCancelBidSuccess] = useState(false)
  const [isCancelListPopup, setCancelListPopup] = useState(false)
  const [isCancelListAccept, setCancelListAccept] = useState(false)
  const [isModifyBidOpen, setModifyBidPopup] = useState(false)
  const [isEditDialogOpen, setEditDialogOpen] = useState(false)
  const [isReCounterDialogOpen, setReCounterDialogOpen] = useState(false)
  const [isBidCancelOpen, setBidCancelOpen] = useState(false)
  const [isReBidSuccessOpen, setReBidSuccessOpen] = useState(false)
  const [isReBidCancelOpen, setReBidCancelOpen] = useState(false)
  const [selectedBidId, setSelectedBidId] = useState(null)
  const [projectId, setprojectId] = useState()
  const [bidId, setbidId] = useState()
  const [tableData, setTableData] = useState(null)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const { userType } = useSelector(state => state.authReducer)
  const [selectedToggle, setSelectedToggle] = useState(false)
  const [isCounterOfferDialogOpen, setCounterOfferDialogOpen] = useState(false)
  const [isCounterAccept, setCounterAcceptOpen] = useState(false)
  const [isCounterReject, setCounterRejectOpen] = useState(false)
  const [isViewPopUpOpen, setIsViewPopUpOpen] = useState(false)
  const [isViewDocumentOpen, setViewDocumentOpen] = useState(false)
  const [isActionRequiredOpen, setActionRequiredOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams()
  const [isOpenRetirementsPopup, setOpenRetirementsPopup] = useState(false)
  const currentPage = Number(searchParams.get('page')) || 1
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  })
  const [searchItem, setSearchItem] = useState('')
  const [selectedToken, setSelectedToken] = useState(null)
  const [filterData, setFilterData] = useState(null)
  const [reason, setReason] = useState('')
  const [selectedRegistry, setSelectedRegistry] = useState(null)
  const [selectedButton, setSelectedButton] = useState(
    userType === 'seller' ? 'BidReceived' : 'BidPlaced'
  )
  const [openDocumentsUpload, setOpenDocumentsUpload] = useState(false)
  const [documentsLink, setDocumentsLink] = useState({})
  const [transactionId, setTransactionId] = useState(0)
  const [bidType, setBidType] = useState('')
  // const [retiremntsData, setRetirementsData] = useState(null);
  useScrollToTop()
  const pageSize = 10

  useEffect(() => {
    if (userType === 'trader') {
    }
  }, [userType])

  const navigate = useNavigate()

  const traderTransformData = data => {
    if (selectedButton === 'BidReceived') {
      return data.paginatedData.map(obj => [
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,

        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onModifyClick={() => {
            setprojectId(obj.p_Id)
            setModifyBidPopup(true)
            handleModifyClick(obj)
          }}
          onViewBidClick={() => {
            setprojectId(obj.p_Id)
            setViewBidOpen(true)
            handleViewBidClick(obj)
          }}
          onCancelListClick={() => {
            handleCancelListPopup(obj)
          }}
          rowData={data}
        />
      ])
    }
    if (selectedButton === 'BidPlaced') {
      return data.paginatedData.map(obj => [
        obj.bidId,
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,
        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onEditClick={() => {
            setbidId(obj.bid_Id)
            setEditDialogOpen(true)
            handleEditClick(obj)
          }}
          onUnbidClick={() => handleCancelBidOk(obj.bid_Id)}
          onRequiredClick={() => {
            setbidId(obj.bid_Id)
            setCounterOfferDialogOpen(true)
            handleRequiredClick(obj)
          }}
          rowData={data}
          isCountered={obj.isCountered}
        />
      ])
    }
    if (selectedButton === 'CancelledBid') {
      return data.map(obj => [
        obj.bidId,
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        obj.bid_type,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,
        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onViewClick={() => {
            handleViewClick(obj.reason)
          }}
        />
      ])
    }
    if (selectedButton === 'CompletedBid') {
      return data.data.data.map(obj => [
        obj['Transaction ID'],
        obj['Bid Id'],
        obj['Project Name'],
        obj['Project ID'],
        obj['No. of Credits'],
        obj['Token Type'],
        obj['bid_type'],
        <p className='font-semibold'>{`$ ${obj['Listed/Bid Price']}`}</p>,

        <Badge varient={obj['Status']}>
          <div className='flex justify-center items-center w-36 text-xs h-5 '>
            {getLabel[obj['Status']]}
          </div>
        </Badge>,
        obj['Status'] === 'Bid Accepted' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onPaymentClick={() => {
              handlePaymentClick(obj['payment_link'])
            }}
            bidType={obj['bid_type']}
          />
        ) : obj['Status'] === 'Action Required' ||
          obj['Status'] === 'Response Received' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onActionClick={() => {
              handleActionClick(obj)
            }}
          />
        ) : (obj['Status'] === 'Transaction Completed' && obj['type_of_request'] !== 'Transfer' )? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onViewDocumentsClick={() => {
              handleViewDocumentsClick(obj.document)
            }}
          />
        ) : (
          '-'
        )
      ])
    }
  }

  const buyerTransformData = data => {
    if (selectedButton === 'BidPlaced') {
      return data.paginatedData.map(obj => [
        obj.bidId,
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,
        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onEditClick={() => {
            setbidId(obj.bid_Id)
            setEditDialogOpen(true)
            handleEditClick(obj)
          }}
          onUnbidClick={() => handleCancelBidOk(obj.bid_Id)}
          onRequiredClick={() => {
            setbidId(obj.bid_Id)
            setCounterOfferDialogOpen(true)
            handleRequiredClick(obj)
          }}
          rowData={data}
          isCountered={obj.isCountered}
        />
      ])
    }
    if (selectedButton === 'CancelledBid') {
      return data.paginatedData.map(obj => [
        obj.bidId,
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,
        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onViewClick={() => {
            handleViewClick(obj.reason)
          }}
        />
      ])
    }
    if (selectedButton === 'CompletedBid') {
      return data.data.data.map(obj => [
        obj['Transaction ID'],
        obj['Bid Id'],
        obj['Project Name'],
        obj['Project ID'],
        obj['No. of Credits'],
        obj['Token Type'],
        <p className='font-semibold'>{`$ ${obj['Listed/Bid Price']}`}</p>,
        <Badge varient={obj['Status']}>
          <div className='flex justify-center items-center w-36 text-xs h-5 '>
            {getLabel[obj['Status']]}
          </div>
        </Badge>,
        obj['Status'] === 'Bid Accepted' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onPaymentClick={() => {
              handlePaymentClick(obj['payment_link'])
            }}
          />
        ) : obj['Status'] === 'Action Required' ||
          obj['Status'] === 'Response Received' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onActionClick={() => {
              handleActionClick(obj['_id'])
            }}
          />
        ) : (obj['Status'] === 'Transaction Completed' && obj['type_of_request'] !== 'Transfer' ) ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onViewDocumentsClick={() => {
              handleViewDocumentsClick(obj.documents)
            }}
          />
        ) : (
          '-'
        )
      ])
    }
  }
  const sellerTransformData = data => {
    if (selectedButton === 'BidReceived') {
      return data.paginatedData.map(obj => [
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,

        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onModifyClick={() => {
            setprojectId(obj.p_Id)
            setModifyBidPopup(true)
            handleModifyClick(obj)
          }}
          onViewBidClick={() => {
            setprojectId(obj.p_Id)
            setViewBidOpen(true)
            handleViewBidClick(obj)
          }}
          onCancelListClick={() => {
            handleCancelListPopup(obj)
          }}
          rowData={data}
        />
      ])
    }
    if (selectedButton === 'CancelledBid') {
      return data.paginatedData.map(obj => [
        obj.bidId,
        obj.projectName,
        obj.projectId,
        obj.noOfCredits,
        obj.tokenType,
        obj.registry,
        <p className='font-semibold'>$ {obj.listedPrice}</p>,
        <ActionButtons
          userType={userType}
          selectedButton={selectedButton}
          onViewClick={() => {
            handleViewClick(obj.reason)
          }}
        />
      ])
    }
    if (selectedButton === 'CompletedBid') {
      return data.data.data.map(obj => [
        obj['Transaction ID'],
        obj['Bid Id'],
        obj['Project Name'],
        obj['Project ID'],
        obj['No. of Credits'],
        obj['Token Type'],
        <p className='font-semibold'>{`$ ${obj['Listed/Bid Price']}`}</p>,
        <Badge varient={obj['Status']}>
          <div className='flex justify-center items-center w-36 text-xs h-5'>
            {getLabel[obj['Status']]}
          </div>
        </Badge>,
        obj['Status'] === 'Action Required' ||
        obj['Status'] === 'Response Received' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onActionClick={() => {
              handleActionClick(obj['_id'])
            }}
          />
        ) : obj['Status'] === 'Payment Completed' ? (
          <ActionButtons
            userType={userType}
            selectedButton={selectedButton}
            status={obj['Status']}
            onUploadClick={() => {
              handleUploadDocs(obj)
            }}
          />
        ) : (
          '-'
        )
      ])
    }
  }

  const transformData = (data, userType, obj) => {
    if (userType === 'seller') {
      return sellerTransformData(data, obj)
    } else if (userType === 'buyer') {
      return buyerTransformData(data)
    } else {
      return traderTransformData(data)
    }
  }

  const fetchDataAndUpdateTable = async () => {
    setIsLoading(true)
    try {
      let response

      if (selectedButton === 'CompletedBid') {
        response = await completeBids(
          {
            page: currentPage,
            pageSize,
            filterData: filterData,
            searchQuery: searchItem
          },
          dispatch
        )
      } else {
        response = await myBids(
          {
            filterData: filterData,
            bid_received: selectedButton === 'BidReceived',
            page: currentPage,
            pageSize,
            searchQuery: searchItem,
            isCancelled: selectedButton === 'CancelledBid',
            isBidPlaced: selectedButton === 'BidPlaced'
          },
          dispatch
        )
      }

      if (response) {
        const transformedData = transformData(response, userType)
        setTableData(transformedData)
        if (selectedButton === 'CompletedBid') {
          setPagination({
            totalItems: response.data.totalDocs,
            totalPages: response.data.totalPages
          })
        } else {
          setPagination({
            totalItems: response.totalDocs,
            totalPages: response.totalPages
          })
        }
      } else {
        toast.error(response.message || 'Failed to fetch data')
      }
    } catch (error) {
      toast.error('Something went wrong!')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchDataAndUpdateTable(selectedToggle)
  }, [
    userType,
    selectedToggle,
    currentPage,
    filterData,
    searchItem,
    selectedButton
  ])

  const handleUploadDocs = data => {
    if (data) {
      if (data.retirement_data) {
        const popUpData = data.retirement_data || {}
        // console.log(popUpData)
        setSelectedRowData({
          'Project Name': data['Project Name'],
          'No. of credits': data['No. of Credits'],
          'Token Type': data['Token Type'],
          pop_up_data: popUpData
        })

        setOpenRetirementsPopup(true)
      } else {
        setSelectedRowData(data._id)
        setOpenDocumentsUpload(true)
      }
    } else {
      console.error('Received null or undefined data:', data)
    }
  }
  const handleViewClick = reason => {
    setIsViewPopUpOpen(true)
    setReason(reason)
    // console.log(reason)
    setIsViewPopUpOpen(true)
  }
  const handleCancelViewClick = () => {
    setReason('')
    setIsViewPopUpOpen(false)
  }
  const handleActionClick = (Id, requestType) => {
    if (userType !== 'trader') {
      setTransactionId(Id)
    } else {
      setTransactionId(Id['_id'])
      setBidType(Id['bid_type'])
    }
    setActionRequiredOpen(true)
  }
  const handleActionRequiredCancel = () => {
    setActionRequiredOpen(false)
  }
  const handleUploadDocumentsClick = () => {
    alert('clicked')
  }

  const handlePaymentClick = paymentLink => {
    if (paymentLink) {
      window.location.href = paymentLink
    } else {
      toast.error('Payment link is not available')
    }
  }
  const handleViewDocumentsClick = rowData => {
    setDocumentsLink(rowData)
    setViewDocumentOpen(true)
    // console.log(documentsLink)
  }

  const handleCancelViewDocumentsClick = () => {
    setDocumentsLink({})
    setViewDocumentOpen(false)
  }

  const handleModifyClick = rowData => {
    setSelectedRowData(rowData)
    setSelectedRowData({
      'Project Name': rowData.projectName,
      'No. of credits': rowData.noOfCredits,
      'Token Type': rowData.tokenType,
      'Project Id': rowData.p_Id,
      'Listed Price': rowData.listedPrice
    })
    setModifyBidPopup(true)
  }

  const handleModifyOk = () => {
    fetchDataAndUpdateTable()
    setModifyPriceOpen(true)
    setModifyBidPopup(false)
  }
  const handleCancelModifyBidClick = () => {
    setModifyBidPopup(false)
  }
  const handleViewBidClick = rowData => {
    setSelectedRowData({
      'Project Name': rowData.projectName,
      'No. of credits': rowData.noOfCredits,
      'Token Type': rowData.tokenType,
      'Project Id': rowData.projectId
    })
    setViewBidOpen(true)
  }

  const handleCancelViewBidClick = () => {
    setViewBidOpen(false)
  }

  const handleViewAcceptCancel = () => {
    setViewAcceptOpen(false)
  }

  const handleViewAcceptOk = () => {
    setViewBidOpen(false)
    setViewAcceptOpen(true)
  }

  const handleModifyPriceCancel = () => {
    setModifyPriceOpen(false)
  }
  const handleGoToBids = () => {
    navigate('/my-bids')
    setModifyPriceOpen(false)
  }
  const handleHomeClick = () => {
    navigate('/')
  }

  const handleCancelBidCancel = () => {
    setCancelBidOpen(false)
  }

  const handleCancelBidSuccess = async (bid_Id, remarks, reason) => {
    try {
      await cancelBids(bid_Id, remarks, reason, dispatch)
      fetchDataAndUpdateTable()
      setCancelBidSuccess(true)
      setCancelBidOpen(false)
    } catch (error) {
      console.log(error)
      toast.error('Error cancelling bid')
    }
  }

  const handleCancelbidSuccessClose = () => {
    setCancelBidSuccess(false)
  }

  const handleCancelBidOk = bidId => {
    setCancelBidOpen(true)
    setSelectedBidId(bidId)
  }
  const handleCancelListPopup = rowData => {
    setSelectedRowData({
      'Project Id': rowData.p_Id
    })
    setCancelListPopup(true)
  }

  const handleCancelListAccept = () => {
    setCancelListAccept(true)
  }

  const handleCancelListAcceptClose = () => {
    fetchDataAndUpdateTable()
    setCancelListAccept(false)
    setCancelListPopup(false)
  }

  const handleCloseCancelListPopup = () => {
    setCancelListPopup(false)
  }

  const handleEditClick = rowData => {
    setSelectedRowData(rowData)
    setSelectedRowData({
      'Project Name': rowData.projectName,
      'No. of credits': rowData.noOfCredits,
      'Token Type': rowData.tokenType,
      'Project Id': rowData.projectId,
      'Bid Price': rowData.listedPrice
    })
    setEditDialogOpen(true)
  }
  const handleCancelEditClick = () => {
    setEditDialogOpen(false)
  }
  const handleCancelEditOk = () => {
    fetchDataAndUpdateTable()
    setEditDialogOpen(false)
    setReBidSuccessOpen(true)
  }

  const handleCancelReCounterClick = () => {
    setReCounterDialogOpen(false)
  }
  const handleCancelReCounterOk = () => {
    fetchDataAndUpdateTable()
    setReCounterDialogOpen(false)
    setReBidSuccessOpen(true)
  }

  const handleCancelBidCancelClick = () => {
    setBidCancelOpen(false)
  }
  const handleCancelBidCancelOk = () => {
    setBidCancelOpen(false)
    setReBidCancelOpen(true)
  }
  const handleReBidSuccessCancel = () => {
    setReBidSuccessOpen(false)
  }
  const handleReBidSuccessOk = () => {
    fetchDataAndUpdateTable()
    setReBidSuccessOpen(false)
  }
  const handleReBidCancelCancel = () => {
    setReBidCancelOpen(false)
  }
  const handleReBidCancelOk = () => {
    setReBidCancelOpen(false)
  }
  const handleFilterButtonClick = () => {
    setFilterDialogOpen(true)
  }

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null)
    setSelectedToken(null)
    setFilterData(null)
    setFilterDialogOpen(false)
  }

  const handleRegistryCheck = e => {
    {
      const selectedValue = e.target.value
      setSelectedRegistry(selectedValue)
    }
  }

  const handleTokenChange = event => {
    const selectedToken = event.target.value
    setSelectedToken(selectedToken)
  }

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false)
    setFilterData({
      registries: selectedRegistry ? [selectedRegistry] : null,
      tokenType: selectedToken
    })
  }

  const handleSearch = () => {
    // console.log(searchItem)
  }

  const handleRequiredClick = rowData => {
    setSelectedRowData(rowData)
    setSelectedRowData({
      'Project Name': rowData.projectName,
      'No. of credits': rowData.noOfCredits,
      'Token Type': rowData.tokenType,
      'Project Id': rowData.projectId,
      'Bid Price': rowData.listedPrice,
      'Countered Credits': rowData.counteredCredits,
      'Countered Price': rowData.counteredPrice
    })
    setCounterOfferDialogOpen(true)
  }
  const handleCancelCounterOfferDialog = () => {
    setCounterOfferDialogOpen(false)
  }
  const handleAcceptOk = () => {
    setCounterAcceptOpen(true)
    fetchDataAndUpdateTable()
    setCounterOfferDialogOpen(false)
  }
  const handleCounterOk = () => {
    setReCounterDialogOpen(true)
    setCounterOfferDialogOpen(false)
  }
  const handleRejectOk = () => {
    setCounterRejectOpen(true)
    setCounterOfferDialogOpen(false)
  }
  const handleCancelAcceptClose = () => {
    setCounterAcceptOpen(false)
  }
  const handleCancelRejectClose = () => {
    setCounterRejectOpen(false)
  }
  const handleClick = buttonName => {
    setSelectedButton(buttonName)
  }

  const getButtonClassNames = buttonName => {
    return selectedButton === buttonName
      ? 'bg-blue-800 text-white border-none rounded-xl py-[2px] w-32 mx-auto mt-6 mb-2'
      : 'border-2 border-black rounded-xl py-[2px] w-32 mx-auto mt-6 mb-2'
  }

  return (
    <div className='bg-gray-100 h-full w-full p-6'>
      <h3 className='text-2xl font-bold mb-6'>My Bids</h3>
      <div className='w-full mt-8 h-[calc(90vh-2.4rem)] bg-white rounded-3xl shadow-formShadow flex flex-col'>
        <div className='flex justify-between pt-5 mb-3'>
          <div className='w-80 border-2 border-grey-800 rounded-lg mx-5 mb-5 '>
            <SearchBar
              onSearch={handleSearch}
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              variant='secondaryxl'
              className='text-black'
              borderColor='border-none'
              placeholderColor='black'
              inputBackground='white'
              svgStrokeColor='black'
              inputWidth='72'
              inputHeight='8'
            />
          </div>

          <div className='pr-7 '>
            <Button
              className='flex justify-center items-center px-2 py-2 mb-3 '
              borderColor={'gray'}
              varient={'secondary'}
              onClick={handleFilterButtonClick}
            >
              <div className='flex gap-x-2 items-center'>
                <Filter className='w-4 h-4' />
                <span>Filter</span>
              </div>
            </Button>
          </div>
        </div>
        <div className='flex gap-4 mx-10 pb-6'>
          <div className='px-4 bg-blue-200 rounded-lg text-center font-medium text-sm py-1'>
            PRESENTS BIDS
            {userType === 'seller' && (
              <div
                className={`${getButtonClassNames(
                  'BidReceived'
                )} cursor-pointer`}
                onClick={() => handleClick('BidReceived')}
              >
                Bid Received
              </div>
            )}
            {userType === 'buyer' && (
              <div
                className={`${getButtonClassNames('BidPlaced')} cursor-pointer`}
                onClick={() => handleClick('BidPlaced')}
              >
                Bid Placed
              </div>
            )}
            {userType === 'trader' && (
              <div className='flex justify-center gap-4 mx-auto'>
                <div
                  className={`${getButtonClassNames(
                    'BidPlaced'
                  )} cursor-pointer`}
                  onClick={() => handleClick('BidPlaced')}
                >
                  Bid Placed
                </div>
                <div
                  className={`${getButtonClassNames(
                    'BidReceived'
                  )} cursor-pointer`}
                  onClick={() => handleClick('BidReceived')}
                >
                  Bid Received
                </div>
              </div>
            )}
          </div>
          <div className='px-4 bg-blue-200 rounded-lg text-center font-medium text-sm py-1'>
            PAST BIDS
            <div className='flex justify-center gap-4 mx-auto'>
              <div
                className={`${getButtonClassNames(
                  'CompletedBid'
                )} cursor-pointer`}
                onClick={() => handleClick('CompletedBid')}
              >
                Completed Bid
              </div>
              <div
                className={`${getButtonClassNames(
                  'CancelledBid'
                )} cursor-pointer`}
                onClick={() => handleClick('CancelledBid')}
              >
                Cancelled Bid
              </div>
            </div>
          </div>
        </div>
        <div className='flex-grow overflow-y-auto'>
          {isLoading ? (
            <>
              <CustomTable
                data={[]}
                headerData={getHeaderData(userType, selectedButton)}
              />
              <div className='flex flex-col gap-y-4 p-4'>
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
              </div>
            </>
          ) : (
            <CustomTable
              data={
                Array.isArray(tableData)
                  ? tableData.map(data => Object.values(data))
                  : []
              }
              headerData={getHeaderData(userType, selectedButton)}
            />
          )}
        </div>
        {pagination.totalPages > 1 && (
          <div className='py-4 px-3'>
            <Pagination
              current={currentPage}
              total={pagination.totalItems}
              pageSize={pageSize}
              setCurrentPage={page => setSearchParams({ page })}
            />
          </div>
        )}
      </div>
      <ActionRequired
        open={isActionRequiredOpen}
        onCancel={handleActionRequiredCancel}
        transactionId={transactionId}
        userType={userType}
        bidType={bidType}
      />
      {isModifyBidOpen && (
        <ModifyBid
          open={isModifyBidOpen}
          onCancel={handleCancelModifyBidClick}
          onModify={handleModifyOk}
          projectId={projectId}
          selectedRowData={selectedRowData}
          selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
        />
      )}
      <ViewBid
        open={isViewBidOpen}
        onCancel={handleCancelViewBidClick}
        projectId={projectId}
        selectedRowData={selectedRowData}
        selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
        ViewBidClose={handleCancelViewBidClick} // Ensure the prop name matches
      />
      {isCounterOfferDialogOpen && (
        <CounterOfferDialog
          open={isCounterOfferDialogOpen}
          onCancel={handleCancelCounterOfferDialog}
          onOk={handleCancelEditOk}
          onAcceptBidClick={handleAcceptOk}
          onCounterBidClick={handleCounterOk}
          onRejectBidClick={handleRejectOk}
          selectedRowData={selectedRowData}
          selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
          bidId={bidId}
        />
      )}
      {isReCounterDialogOpen && (
        <ReCounterDialog
          open={isReCounterDialogOpen}
          onCancel={handleCancelReCounterClick}
          onOk={handleCancelReCounterOk}
          bidId={bidId}
          selectedRowData={selectedRowData}
          selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
        />
      )}
      <ViewPopUp
        open={isViewPopUpOpen}
        onCancel={handleCancelViewClick}
        reason={reason}
      />
      <ViewDocumentPopUp
        open={isViewDocumentOpen}
        onCancel={handleCancelViewDocumentsClick}
        documentsLink={documentsLink}
      />
      <AcceptPopUp
        open={isViewAcceptOpen}
        onCancel={handleViewAcceptCancel}
        onOk={handleViewAcceptCancel}
        title='Thanks for accepting the bid !'
        okButtonText='Go back'
        isRequiredStatus={true}
        statusType={
          <span>
            Payment link sent. Once buyer pays, we'll notify you and provide
            details for credit transfer or retire. Check{' '}
            <span className='font-bold'> History tab </span> for updates
          </span>
        }
        isRequiredCancelButton={false}
        isRequiredColor='green'
        width={400}
      />
      <AcceptPopUp
        open={isCounterAccept}
        onCancel={handleCancelAcceptClose}
        onOk={handleCancelAcceptClose}
        title='Counter Offer Accepted  Successfully!'
        okButtonText='Go back'
        isRequiredStatus={false}
        isRequiredCancelButton={false}
        isRequiredColor='green'
        width={400}
      />
      <AcceptPopUp
        open={isCounterReject}
        onCancel={handleCancelRejectClose}
        onOk={handleCancelRejectClose}
        title='Counter Offer Rejected Successfully!'
        okButtonText='Go Back'
        isRequiredStatus={false}
        isRequiredCancelButton={false}
        isRequiredColor='red'
        width={400}
      />
      <AcceptPopUp
        open={isModifyPriceOpen}
        onCancel={handleModifyPriceCancel}
        onOk={handleGoToBids}
        notOk={handleHomeClick}
        title='Bid Modified Successfully!'
        statusType={
          <span>
            Check the status in <span className='font-bold'> My Bids </span> Tab
          </span>
        }
        okButtonText='Go to My bids'
        cancelButtonText='Home'
        isRequiredStatus={false}
        isRequiredColor='green'
        isRequiredCancelButton={true}
        width={400}
      />
      <Cancelbid
        open={isCancelBidOpen}
        onCancel={handleCancelBidCancel}
        onOk={(remarks, reason) =>
          handleCancelBidSuccess(selectedBidId, remarks, reason)
        }
        bidId={selectedBidId}
      />
      <AcceptPopUp
        open={isCancelBidSuccess}
        onCancel={handleCancelbidSuccessClose}
        onOk={handleCancelbidSuccessClose}
        title='Bid canceled Successfully !!!'
        okButtonText='Go Back'
        isRequiredStatus={false}
        isRequiredCancelButton={false}
        isRequiredColor='red'
        width={400}
      />
      <CancelListPopup
        open={isCancelListPopup}
        onOk={handleCancelListAccept}
        onCancel={handleCloseCancelListPopup}
        selectedRowData={selectedRowData}
      />
      <AcceptPopUp
        open={isCancelListAccept}
        onCancel={handleCancelListAcceptClose}
        onOk={handleCancelListAcceptClose}
        title='Bid Unlisted Successfully!'
        okButtonText='Go back'
        isRequiredStatus={false}
        isRequiredColor='red'
        isRequiredCancelButton={false}
        width={400}
      />
      {isEditDialogOpen && (
        <EditDialog
          open={isEditDialogOpen}
          onCancel={handleCancelEditClick}
          onOk={handleCancelEditOk}
          bidId={bidId}
          selectedRowData={selectedRowData}
          selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
        />
      )}
      <BidCancelBox
        open={isBidCancelOpen}
        onCancel={handleCancelBidCancelClick}
        onOk={handleCancelBidCancelOk}
      />
      <ReBidSuccessBox
        open={isReBidSuccessOpen}
        onCancel={handleReBidSuccessCancel}
        onOk={handleReBidSuccessOk}
      />
      <ReBidCancelBox
        open={isReBidCancelOpen}
        onCancel={handleReBidCancelCancel}
        onOk={handleReBidCancelOk}
      />
      {isFilterDialogOpen && (
        <FilterBox
          open={isFilterDialogOpen}
          onCancel={handleFilterDialogClose}
          onOk={handleFilterDialogSubmit}
          page='bids'
          selectedRegistry={selectedRegistry}
          onCheckRegistry={handleRegistryCheck}
          selectedToken={selectedToken}
          onSelectToken={handleTokenChange}
        />
      )}
      <UploadCompleteBidsDocuments
        open={openDocumentsUpload}
        onCancel={() => {
          setOpenDocumentsUpload(false)
          fetchDataAndUpdateTable()
        }}
        data={selectedRowData}
      />
      <RetirementPopup
        open={isOpenRetirementsPopup}
        onCancel={() => {
          setOpenRetirementsPopup(false)
          fetchDataAndUpdateTable()
        }}
        selectedRowData={selectedRowData}
        selectedColumns={['Project Name', 'No. of credits', 'Token Type']}
      />
    </div>
  )
}

export default ListingsPage
